import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import MasterService from "@/service/restfulService/CCOnboardMasterService";

export default function crossSLCardSubmit(
  ccFormValue: Ref<FormCC>,
  page0Overlay: Ref<boolean>,
  biometricVerification: Ref<string>,
  isTimeOut: Ref<boolean>,
  isSessionEnd: Ref<boolean>,
  prop: any,
  creditLimit: Ref<string>,
  failedStatus: Ref<boolean>,
  jumpStep: (value: number, name: string, page: string) => void
): void {
  const exist = ref(false);
  page0Overlay.value = true;

  // update card Id
  const cardSubmissionRequestModel = {
    webFormRequestId: ccFormValue.value.webFormRequestId,
    cardId: ccFormValue.value.selectedCard.cardId,
  };
  MasterService.cardSubmission(
    cardSubmissionRequestModel,
    ccFormValue.value.token
  )
    .then((res) => {
      if (res.status == 200) {
        // check gross salary change if already done pa rulescheck
        if (
          ccFormValue.value.basicInformation.idType == "0" &&
          ccFormValue.value.ekyc.preStatus != "" &&
          ccFormValue.value.preAss.webFormRequestId
        ) {
          const requestModel = {
            webFormRequestId: ccFormValue.value.webFormRequestId,
            preRequestId: ccFormValue.value.preAss.webFormRequestId,
            grossSalary: ccFormValue.value.basicInformation.grossSalary,
          };
          MasterService.preAssesmentValidate(
            requestModel,
            ccFormValue.value.token
          )
            .then((res) => {
              if (res.status == 200) {
                if (res.data.responseModel.check == "Exist") {
                  exist.value = true;
                } else {
                  exist.value = false;
                }
                continueFunction();
              }
            })
            .catch((e) => {
              if (e.response.data.code == "WB-401") {
                // EndSession
                isTimeOut.value = false;
                isSessionEnd.value = true;
              }
              page0Overlay.value = false;
              jumpStep(14, "denied2", "3");
            });
        } else if (ccFormValue.value.basicInformation.idType == "0") {
          continueFunction();
        } else {
          jumpStep(4, "", "3");
        }
      }
    })
    .catch((e) => {
      if (e.response.data.code == "WB-401") {
        // EndSession
        isTimeOut.value = false;
        isSessionEnd.value = true;
      }
      page0Overlay.value = false;
    });

  const continueFunction = () => {
    //type others || type == bio && bioflag false
    if (
      (ccFormValue.value.ekyc.status == "" ||
        ccFormValue.value.ekyc.status == "PENDING" ||
        ccFormValue.value.ekyc.status == "FAILED") &&
      biometricVerification.value != "true"
    ) {
      failedStatus.value = false;
      page0Overlay.value = false;
      jumpStep(2, "", "1");
    }

    //Check otp
    else {
      if (exist.value == true) {
        page0Overlay.value = false;
        jumpStep(4, "", "3");
      } else {
        const requestModel = {
          webFormRequestId: ccFormValue.value.webFormRequestId,
          name: ccFormValue.value.basicInformation.name,
          icNo: ccFormValue.value.basicInformation.idNo,
          dateOfBirth: ccFormValue.value.basicInformation.dob,
          cardBusinessCode: prop.cardId,
          nationalityCode: ccFormValue.value.basicInformation.nationality,
          phoneNo:
            ccFormValue.value.basicInformation.countryCode +
            ccFormValue.value.basicInformation.mobileNo,
          grossIncome:
            ccFormValue.value.basicInformation.grossSalary.toString(),
          netIncome: ccFormValue.value.basicInformation.netSalary.toString(),
          refNo: ccFormValue.value.refNo,
        };
        MasterService.preAssesment(requestModel, ccFormValue.value.token)
          .then((res) => {
            if (res.status == 200) {
              // page3Overlay.value = false;
              ccFormValue.value.preAss.webFormRequestId =
                res.data.responseModel.webFormRequestId;
              ccFormValue.value.dsrBurst = res.data.responseModel.dSRStatus;
              ccFormValue.value.dropOffStep = 5;
              creditLimit.value = res.data.responseModel.preAssessLimit;
              ccFormValue.value.ctosScore = res.data.responseModel.ctosScore;
              if (res.data.responseModel.preAssessStatus == "DECLINED") {
                page0Overlay.value = false;
                jumpStep(14, "denied2", "3");
              } else {
                ccFormValue.value.ekyc.preStatus =
                  res.data.responseModel.preAssessStatus;
                page0Overlay.value = false;
                jumpStep(4, "", "3");
              }
            }
          })
          .catch((e) => {
            if (e.response.data.code == "WB-401") {
              // EndSession
              isTimeOut.value = false;
              isSessionEnd.value = true;
            }
            page0Overlay.value = false;
            ccFormValue.value.ekyc.preStatus = "DOWN";
            jumpStep(4, "", "3");
            // jumpStep(14, "denied2", "3");
          });
      }
    }
  };
}
